/**
 * Cross-page selection semantics for the People list.
 *
 * The list distinguishes "every loaded row is checked" from "the user chose
 * Select all across the whole filtered result set". Several bulk actions can
 * only act on the profiles that are actually loaded, so they disable when the
 * selection notionally covers more rows than the page holds.
 */

export interface PeopleSelectionSummary {
  /** Select-all across the whole result set (chosen, or implied by checking every row). */
  allSelected: boolean;
  /** `meta.pagination.total` for the current search/filter; `-1` when unknown. */
  totalCount: number;
  /** Number of loaded rows currently checked. */
  selectedCount: number;
}

/**
 * True when the selection covers more profiles than are loaded on the page —
 * the "select all across pages" state. Per-row bulk actions (unsubscribe,
 * add-to-segment, invite test users, tracking consent) disable in this state;
 * delete switches to its filter-based payload instead.
 */
export function selectionExceedsLoaded({ allSelected, totalCount, selectedCount }: PeopleSelectionSummary): boolean {
  return allSelected && totalCount > selectedCount;
}
